import React from 'react';

const Logo = ({
    width = 120,
    height = 40,
    className = '',
    textColor = 'currentColor',
    accentColor = '#10b981', // verde saludable
    inline = false,
    fontSize = 40
}) => {
    const Tag = inline ? 'span' : 'p';
    return (
        <><Tag className={className} style={{
            fontFamily: "Marck Script",
            fontWeight: 400,
            fontStyle: "normal",
            fontSize: `${fontSize}px`,
            color: "rgb(3 105 161)"
        }}>
            heaful
        </Tag><span style={{ fontSize: `12px` }}>(beta)</span></>
    );
};

export default Logo;
